import {useMemo} from 'react';
import {ValueCandidate, ValueSource} from './valueSource.types';

/** The value a filter field accepts to mean "this field is empty". It names no record, so no
 * record source lists or labels it. The report service reads NONE on ASSIGNED as "no assignee"
 * and accepts it on no other field, which is why OWNER, sharing the person source, has none. */
export const EMPTY_VALUE_BY_FILTER_FIELD: Record<string, string> = {ASSIGNED: 'NONE'};

/** `source` with `candidate` offered first and labelled locally. */
export function withEmptyValue(source: ValueSource, candidate: ValueCandidate): ValueSource {
	return {
		...source,
		exclusiveIds: [candidate.id],
		useCandidates(search, selectedIds, options) {
			const result = source.useCandidates(
				search,
				selectedIds?.filter(id => id !== candidate.id),
				options
			);
			const q = search.trim().toLowerCase();
			const matches = !q || candidate.label.toLowerCase().includes(q);
			// Always called from the picker's useCandidates, so the hook order is fixed. Keyed on the
			// inner list so the prepended list is only rebuilt when that one changes.
			const items = useMemo(
				() => (matches ? [candidate, ...result.items] : result.items),
				[result.items, matches, candidate]
			);
			return {...result, items};
		},
		resolveLabels(ids) {
			const rest = ids.filter(id => id !== candidate.id);
			const labels = source.resolveLabels(rest);
			return ids.includes(candidate.id) ? {[candidate.id]: candidate.label, ...labels} : labels;
		},
	};
}
